import moment from "moment";
import { mapState } from "vuex";
import {
  DATE_FORMAT_V2,
  otTypeFlexible,
  STATUS_FLEXIBLE_TEXT,
  TIME_PM,
  TIME_STAFF,
} from "../../components/commons/commonConstant";
import { checkShowWithLastTimesheet, downloadFile, getInfoStaff, getMessages } from "../../components/commons/commons";
import InfoIFlexibleItem from "../../components/OvertimeFlexibleDetail/InfoIFlexibleItem.vue";
import OvertimeModal from "../../components/OvertimeManagement/OvertimeModal.vue";
import ConfirmOvertimeModal from "../../components/OvertimeManagement/ConfirmOvertimeModal.vue";
import http from "../../store/modules/helpers/httpInterceptor";
import { Tooltip } from "@/components";
export default {
  name: "Overtime-Flexible-Detail",
  components: { InfoIFlexibleItem, OvertimeModal, ConfirmOvertimeModal, Tooltip },
  data() {
    return {
      page: "Overtime-Flexible-Detail",
      OTForm: this.$form.createForm(this, { name: "OT Request" }),
      ConfirmForm: this.$form.createForm(this, { name: "Confirm Request" }),
      CancelForm: this.$form.createForm(this, { name: "Cancel Request" }),
      RejectForm: this.$form.createForm(this, { name: "Reject Request" }),
      timeout: "",
      isAvaiableToDownLoad: false,
      visibleModal: false,
      visibleModalReject: false,
      visibleModalCancel: false,
      visibleModalConfirm: false,
      required_reason: false,
      loadingDetail: false,
      isLoading: false,
      id: this.$route.params.id,
      overtimeInformation: [
        { key: "status", label: "Status:" },
        { key: "title", label: "Title:" },
        { key: "staff", label: "Staff:" },
        { key: "project", label: "Project:" },
        { key: "project_manager", label: "Project Manager:" },
        { key: "manager", label: "Manager:" },
        { key: "cc", label: "CC:" },
        { key: "description", label: "Description:" },
        { key: "reason_reject", label: "Reason for rejection:" },
        { key: "reason_cancel", label: "Reason for cancellation:" },
        { key: "files", label: "Attach files:" },
      ],
      overtimePlan: [
        { key: "date", label: "Date:" },
        { key: "type", label: "Type:" },
        { key: "otTime", label: "OT Time:" },
      ],
      overtimeActual: [
        { key: "checkTime", label: "Check time:" },
        // { key: "otPay", label: "OTpay (hours):" },
        // { key: "otPayConfirm", label: "OTpay confirmation:" },
        // { key: "reasonConfirm", label: "Reason for confirmation:" },
      ],
      dataOvertimeInformation: {
        status: "",
        title: "",
        staff: "",
        project: "",
        project_manager: [],
        manager: [],
        cc: [],
        description: "",
        reason_reject: "",
        reason_cancel: "",
        files: [],
      },
      dataOvertimePlan: {
        date: "--",
        type: "--",
        shift: "--",
      },
      dataOvertimeActual: {
        checkTime: "--",
        // otPay: "--",
        // otPayConfirm: "--",
        // reasonConfirm: "--",
      },
      OTPayColumns: [
        {
          dataIndex: "shift",
          slots: {
            title: "titleShift",
          },
          key: "shift",
          width: "10%",
        },
        {
          title: "Start OT time",
          dataIndex: "check_in_actual",
          customRender(value) {
            return value ?? "-";
          },
          key: "start_time",
          width: "15%",
          align: "center",
        },
        {
          title: "End OT time",
          dataIndex: "check_out_actual",
          key: "end_time",
          customRender(value) {
            return value ?? "-";
          },
          width: "15%",
          align: "center",
        },
        {
          title: "OTpay (hours)",
          dataIndex: "duration_actual",
          key: "duration_actual",
          width: "20%",
        },
        {
          title: "OTpay confirmation",
          dataIndex: "duration_confirm",
          customRender(value) {
            return `${value ?? ""}`;
          },
          key: "duration_confirm",
          width: "20%",
        },
        {
          title: "Reason for confirmation",
          dataIndex: "reason",
          key: "reason",
          width: "20%",
        },
      ],
      dataOTPay: [],
      LayoutConfirm: {
        labelCol: { span: 12 },
        wrapperCol: { span: 12 },
      },
      LayoutRequest: {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
      },
    };
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      overtimeRequestDetail: (state) => state.overtime.overtimeRequestDetail,
      employeeList: (state) => state.application.employeeList,
      otTypeList: (state) => state.application.otTypeList,
      overtimeShift: (state) => state.overtime.overtimeShift,
      projectListPermission: (state) => state.application.projectListPermission,
      lastTimesheet: (state) => state.application.lastTimesheet,
      timeServer: (state) => state.application.timeServer,
    }),
    generateTextConfirm() {
      const { status } = this.overtimeRequestDetail;
      if (status === STATUS_FLEXIBLE_TEXT[3]) {
        return "Edit confirmation";
      }
      return "Confirm";
    },
  },
  watch: {
    overtimeRequestDetail(newValue) {
      this.getOvertimeInformation(newValue);
    },
    visibleModalConfirm(newValue) {
      if (!newValue) {
        this.handleClearData();
        this.required_reason = false;
      }
    },
    visibleModalCancel(newValue) {
      if (!newValue) {
        this.handleClearData();
      }
    },
    visibleModalReject(newValue) {
      if (!newValue) {
        this.handleClearData();
      }
    },
    visibleModal(newValue) {
      if (!newValue) {
        this.loadingDetail = false;
        this.isLoading = false;
      }
    },
  },
  created() {
    this.getLastTimesheetInfo();
    this.$store.dispatch("application/getOTTypeList");
    // Get Time Server
    this.$store.dispatch("application/getTimeServer");
  },
  beforeMount() {
    this.getOvertimeRequestDetail();
  },
  mounted() {},

  methods: {
    moment,
    getOvertimeInformation(data) {
      if (data) {
        const {
          status,
          title,
          requester,
          project,
          pms,
          ccMails,
          approver,
          description,
          reason,
          fileAttach,
          overtimeDate,
          requestType,
          dateType,
          startTime,
          endTime,
          overtimePayDetail,
        } = data;
        setTimeout(() => {
          this.dataOvertimeInformation = {
            status: status ?? "",
            title: title ?? "",
            staff: getInfoStaff(requester),
            project: project?.projectName ?? "",
            project_manager: pms && pms.length > 0 ? pms.map((pm) => getInfoStaff(pm)) : [],
            manager: getInfoStaff(approver),
            cc: ccMails && ccMails.length > 0 ? ccMails.map((mail) => getInfoStaff(mail)) : [],
            description: description ?? "",
            reason_reject: reason ?? "",
            reason_cancel: reason ?? "",
            files: fileAttach && fileAttach.length > 0 ? fileAttach.map((file) => file.name) : [],
          };
          this.dataOvertimePlan = {
            date: `${overtimeDate ?? ""} - ${dateType ?? ""} `,
            type: requestType ? otTypeFlexible[requestType] ?? "" : "",
            otTime: `${startTime ?? ""} - ${endTime ?? ""}`,
          };
          this.dataOvertimeActual = overtimePayDetail
            ? {
                checkTime: (overtimePayDetail?.check_in ?? "") + " - " + (overtimePayDetail?.check_out ?? ""),
              }
            : {
                checkTime: "--",
              };
          if (overtimePayDetail?.details) {
            this.dataOTPay = overtimePayDetail?.details.map((item, index) => {
              return {
                ...item,
                keyHour: `otPayConfirm-${index}`,
                keyReason: `reasonConfirm-${index}`,
                required_reason: !(item?.duration_actual === item?.duration_confirm),
              };
            });
          }
        }, 500);
      }
    },
    checkShow(status, key) {
      if (status && key) {
        if (key === "reason_reject") {
          if (status === STATUS_FLEXIBLE_TEXT[2] || status === STATUS_FLEXIBLE_TEXT[4]) {
            return true;
          } else return false;
        } else if (key === "reason_cancel") {
          if (status === STATUS_FLEXIBLE_TEXT[6]) {
            return true;
          } else return false;
        } else return true;
      } else {
        return true;
      }
    },
    getOvertimeRequestDetail() {
      this.loadingDetail = true;
      this.$store.dispatch("overtime/getOvertimeRequestDetail", this.id).finally(() => {
        this.loadingDetail = false;
      });
    },
    getLastTimesheetInfo() {
      this.$store
        .dispatch("application/getEndDateOfLastTimsheet")
        .then((res) => {
          if (!res) {
            this.$message.error(res.message, 5);
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data?.message, 5);
        });
    },
    handleClickCancel() {
      this.loadingDetail = true;
      setTimeout(() => {
        this.loadingDetail = false;
        this.visibleModalCancel = true;
      }, 200);
    },
    handleClickConfirm() {
      if (this.overtimeRequestDetail) {
        const { overtimePayDetail } = this.overtimeRequestDetail;
        if (!overtimePayDetail || !overtimePayDetail?.details || overtimePayDetail?.details.length <= 0) {
          this.$message.error("Cannot confirm request OT when not have OT pay", 5);
        } else {
          this.loadingDetail = true;
          setTimeout(() => {
            this.loadingDetail = false;
            this.visibleModalConfirm = true;
          }, 1000);
        }
      }
    },
    async handleClickApprove() {
      this.loadingDetail = true;
      const result = await this.updateStatusFlexible({
        requestId: this.overtimeRequestDetail.id,
        action: "approve",
      });
      if (result) {
        this.loadingDetail = false;
        this.getOvertimeRequestDetail();
      }
      this.loadingDetail = false;
    },
    handleClickReject() {
      this.loadingDetail = true;
      setTimeout(() => {
        this.loadingDetail = false;
        this.visibleModalReject = true;
      }, 200);
    },
    handleConfirm() {
      this.ConfirmForm.validateFields(async (err, values) => {
        if (!err) {
          const data = this.dataOTPay.map((item) => {
            return {
              ...item,
              duration_confirm: values[item.keyHour],
              reason: values[item.keyReason],
            };
          });
          const payload = {
            requestId: this.overtimeRequestDetail.id,
            action: "confirm",
            details: data,
          };
          const result = await this.updateStatusFlexible(payload);
          if (result) {
            this.getOvertimeRequestDetail();
          }
        }
      });
    },
    handleExecuteCancel() {
      this.CancelForm.validateFields(async (err, values) => {
        if (!err) {
          if (values?.reasonCancel && values?.reasonCancel.trim() !== "") {
            const result = await this.updateStatusFlexible({
              requestId: this.overtimeRequestDetail.id,
              action: "cancel",
              reason: values?.reasonCancel ?? "",
            });
            if (result) {
              this.getOvertimeRequestDetail();
            }
          } else {
            this.$message.error("Reason cancel is required", 5);
          }
        }
      });
    },
    handleReject() {
      this.RejectForm.validateFields(async (err, values) => {
        if (!err) {
          if (values?.reasonReject && values?.reasonReject.trim() !== "") {
            const payload = {
              requestId: this.overtimeRequestDetail.id,
              reason: values?.reasonReject ?? "",
              action: "reject",
            };
            const result = await this.updateStatusFlexible(payload);
            if (result) {
              this.getOvertimeRequestDetail();
            }
          } else {
            this.$message.error("Reason reject is required", 5);
          }
        }
      });
    },
    handleCancelAction() {
      this.visibleModalReject = false;
      this.visibleModalCancel = false;
      this.visibleModalConfirm = false;
    },
    handleClearData() {
      this.ConfirmForm.resetFields();
      this.RejectForm.resetFields();
      this.CancelForm.resetFields();
    },
    getInfoStaff,
    checkShowEdit(record) {
      return (
        this.checkShowExpired(record.overtimeDate, TIME_STAFF) &&
        record.createdBy?.username === this.userInfo.userName &&
        (record.status === STATUS_FLEXIBLE_TEXT[0] ||
          (record.status === STATUS_FLEXIBLE_TEXT[1] &&
            this.getPmsProject(record).includes(record.createdBy?.username)))
      );
    },
    checkShowCancel(record) {
      return (
        (record.status === STATUS_FLEXIBLE_TEXT[0] &&
          record.requester?.username === this.userInfo.userName &&
          this.checkShowExpired(record.overtimeDate, TIME_STAFF)) ||
        (record.status === STATUS_FLEXIBLE_TEXT[1] &&
          this.getPmsProject(record).includes(this.userInfo.userName) &&
          this.getPmsProject(record).includes(record.createdBy?.username ?? "") &&
          this.checkShowExpired(record.overtimeDate, TIME_PM))
      );
    },
    checkShowConfirm(record) {
      return (
        this.checkShowDayOvertime(record.overtimeDate, record.endTime) &&
        this.checkShowExpired(record.overtimeDate, TIME_PM) &&
        (record.status === STATUS_FLEXIBLE_TEXT[1] || record.status === STATUS_FLEXIBLE_TEXT[3]) &&
        this.getPmsProject(record).includes(this.userInfo.userName)
      );
    },
    checkShowApproveReject(record) {
      return (
        this.checkShowExpired(record.overtimeDate, TIME_PM) &&
        ((record.status === STATUS_FLEXIBLE_TEXT[0] && this.getPmsProject(record).includes(this.userInfo.userName)) ||
          (record.status === STATUS_FLEXIBLE_TEXT[3] &&
            this.getManager(record) === this.userInfo.userName &&
            this.checkShowDayOvertime(record.overtimeDate, record.endTime)))
      );
    },
    getManager(record) {
      const { approver } = record;
      if (approver) {
        return approver.username;
      } else {
        return "";
      }
    },
    getPmsProject(record) {
      const { pms } = record;
      const result = [];
      if (pms && pms.length > 0) {
        pms.forEach((pm) => {
          result.push(pm.username);
        });
      }
      return result;
    },
    checkShowExpired(date, hour) {
      return checkShowWithLastTimesheet(
        date,
        this.lastTimesheet?.last_timesheet_period_end_date,
        hour,
        DATE_FORMAT_V2,
        this.timeServer
      );
    },
    checkShowDayOvertime(date, time) {
      if (date && time) {
        let dateCompare = date + " " + time;
        return moment(new Date()).isAfter(moment(dateCompare, "DD/MM/YYYY HH:mm"));
      }
      return false;
    },
    handleChangeOTPayConfirm(value, max) {
      if (value > max) {
        this.$message.error("OTpay confirmation can not be higher than total time of shift is " + max, 5);
      }
    },
    handleBlur(event, originValue, key, index) {
      if (event.target.value) {
        const numberFixed = Number.parseFloat(event.target.value).toFixed(2);
        this.ConfirmForm.setFieldsValue({ [key]: numberFixed });
        if (Number.parseFloat(originValue).toFixed(2) === numberFixed) {
          this.dataOTPay[index].required_reason = false;
        } else {
          this.dataOTPay[index].required_reason = true;
        }
      } else {
        this.ConfirmForm.setFieldsValue({
          [key]: originValue,
        });
      }
    },
    // handleFocus() {
    //   this.required_reason = false;
    //   this.ConfirmForm.setFields({
    //     reasonConfirm: {
    //       value: this.ConfirmForm.getFieldValue("reasonConfirm"),
    //     },
    //   });
    // },
    async updateStatusFlexible(payload) {
      return this.$store
        .dispatch("overtime/updateStatusOTFlexibleRequest", payload)
        .then((res) => {
          let check = "success";
          if (parseInt(res.code) === 200 || parseInt(res.code) === 201) {
            check = "success";
            getMessages(res.message).forEach((msg) => {
              this.$message.success(msg, 5);
            });
          } else if (parseInt(res.code) === 207) {
            check = "warn";
            const messages = getMessages(res.message);
            if (messages && messages.length > 0) {
              for (let i = 0; i < messages.length; i++) {
                if (i === 0) {
                  this.$message.success(messages[i], 5);
                } else {
                  this.$message.warn(messages[i], 5);
                }
              }
            }
          } else {
            check = "fail";
          }
          if (check === "success" || check === "warn") {
            this.visibleModalConfirm = false;
            this.visibleModalCancel = false;
            this.visibleModalReject = false;

            return true;
          } else {
            getMessages(res.message).forEach((err) => {
              this.$message.error(err, 5);
            });
            return false;
          }
        })
        .catch((errors) => {
          getMessages(errors.response?.data?.message).forEach((err) => {
            this.$message.error(err, 5);
          });
          return false;
        });
    },
    handleBack() {
      this.$router.push("/timesheet/overtime-management");
    },
    // Xử lý button Edit
    async handleClickEdit() {
      this.loadingDetail = true;
      setTimeout(() => {
        this.loadingDetail = false;
        this.visibleModal = true;
      }, 1000);
    },
    // Xử lý form Edit OT
    handleCancel() {
      this.visibleModal = false;
    },
    // Xử lý file
    handleDownloadFile(name) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        http
          .get(`/tms/overtime-management/v2/${this.overtimeRequestDetail.id}/download?name=` + name, {
            responseType: "blob",
          })
          .then((res) => {
            downloadFile(res.data, name);
            return res.data;
          })
          .catch((err) => {
            throw err;
          });
      }, 500);
    },
  },
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
};
